



















export default {
  name: "Tabs",
  props: ['defaultTab', 'tabs'],
  methods: {
    onChange(key: string) {
      // @ts-ignore
      this.$emit('change', key);
    }
  }
}
